import { browserHistory } from "../../../store/utils/history";
import type { AccountQuery_viewer_account_byEmail } from "../../../use-cases/settings/graphql/gql/AccountQuery";
import type { Location } from "../../routes/AppRoutes";
import { getMainPage } from "../../routes/routeUtils";
import { getRedirectModal, redirectModal } from "../../routes/tryModal";

export function redirectDependingOnPermissions(
  account: AccountQuery_viewer_account_byEmail,
  redirectedFromCallbackUrl: boolean,
) {
  const currentLocation = browserHistory.location;
  const newLocation: Location = {
    pathname:
      new URLSearchParams(window.location.search).get("returnTo") ||
      getMainPage(account.permissions),
  };

  // Redirect only if this is a new login. Otherwise, avoid redirecting on new tabs, etc.
  const location = redirectedFromCallbackUrl ? newLocation : currentLocation;

  const modal = getRedirectModal(location);

  if (modal) {
    redirectModal(modal);
  } else {
    browserHistory.replace(location);
  }
}
